import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PlanCodeBookPublishMutationVariables = Types.Exact<{
  importId: Types.Scalars['uuid']['input'];
}>;


export type PlanCodeBookPublishMutation = { __typename?: 'mutation_root', plan_code_book_publish?: { __typename?: 'CodeBookPublishPlanOutput', first_import: boolean, added: number, removed: number, changed: number, unchanged: number, links_on_file: number, links_at_risk: number, correction_problems: Array<{ __typename?: 'CodeBookCorrectionProblem', page_number: number, line_text: string, problem: string }>, at_risk?: Array<{ __typename?: 'CodeSectionLinkAtRisk', rule_code?: string | null, rule_title?: string | null, jurisdiction_name?: string | null, section_number?: string | null, citation_text?: string | null }> | null } | null };


export const PlanCodeBookPublishDocument = gql`
    mutation planCodeBookPublish($importId: uuid!) {
  plan_code_book_publish(input: {import_id: $importId}) {
    first_import
    added
    removed
    changed
    unchanged
    links_on_file
    links_at_risk
    correction_problems {
      page_number
      line_text
      problem
    }
    at_risk {
      rule_code
      rule_title
      jurisdiction_name
      section_number
      citation_text
    }
  }
}
    `;
export type PlanCodeBookPublishMutationFn = Apollo.MutationFunction<PlanCodeBookPublishMutation, PlanCodeBookPublishMutationVariables>;

/**
 * __usePlanCodeBookPublishMutation__
 *
 * To run a mutation, you first call `usePlanCodeBookPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanCodeBookPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planCodeBookPublishMutation, { data, loading, error }] = usePlanCodeBookPublishMutation({
 *   variables: {
 *      importId: // value for 'importId'
 *   },
 * });
 */
export function usePlanCodeBookPublishMutation(baseOptions?: Apollo.MutationHookOptions<PlanCodeBookPublishMutation, PlanCodeBookPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlanCodeBookPublishMutation, PlanCodeBookPublishMutationVariables>(PlanCodeBookPublishDocument, options);
      }
export type PlanCodeBookPublishMutationHookResult = ReturnType<typeof usePlanCodeBookPublishMutation>;
export type PlanCodeBookPublishMutationResult = Apollo.MutationResult<PlanCodeBookPublishMutation>;
export type PlanCodeBookPublishMutationOptions = Apollo.BaseMutationOptions<PlanCodeBookPublishMutation, PlanCodeBookPublishMutationVariables>;